import './VerificationStatus.scss';

import { IconAlertErrorRed, IconAlertSuccessGreen } from '@hulu-react-style-components/icons';
import cx from 'classnames';
import { bem } from 'mission-control-common-components';
import { memo } from 'react';

import Tooltip from '../../../Tooltip';

const [, element] = bem('verification-status');

type Props = {
  autoVerified?: boolean;
  isVerified: boolean;
  index: number;
  shouldShowUnverifiedTooltip?: boolean;
  unverifiedTooltipMessage?: string;
};

const VerificationStatus = ({
  autoVerified,
  isVerified,
  index,
  shouldShowUnverifiedTooltip,
  unverifiedTooltipMessage,
}: Props): React.JSX.Element => {
  if (autoVerified)
    return (
      <div data-testid="auto-verified-icon">
        <IconAlertSuccessGreen
          aria-label="auto-verified"
          className={cx(element('verified-icon'), element('blue-verified-icon'))}
        />
      </div>
    );

  if (isVerified) {
    return (
      <div data-testid="verified-icon">
        <IconAlertSuccessGreen
          className={`${element('verified-icon')} ${element('verified-icon-success')}`}
          aria-label="verified"
        />
      </div>
    );
  }

  return (
    <Tooltip
      id={`${index}-unverified`}
      message={unverifiedTooltipMessage ?? ''}
      disable={!shouldShowUnverifiedTooltip || !unverifiedTooltipMessage}
    >
      <div data-testid="unverified-icon">
        <IconAlertErrorRed className={element('verified-icon')} aria-label="not verified" />
      </div>
    </Tooltip>
  );
};

export default memo(VerificationStatus);
